import api from "./axios";

/**
 * The signed-in buyer's purchases, and asking a seller for a refund on one.
 * @see mintly-back/src/routes/purchaseRoutes
 */

/**
 * Everything I've bought, newest first — each with whether a refund can be asked for
 * and where a request stands.
 */
export const getPurchases = async () => {
  try {
    const response = await api.get("/purchases");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Cancel a subscription bought here. Nothing is charged again, and access runs to the
 * end of the period already paid for.
 */
export const cancelPurchaseSubscription = async (subscriptionId) => {
  try {
    const response = await api.post(`/keepz/subscriptions/${subscriptionId}/cancel`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/** Ask the seller for a refund. The reason is shown to them. */
export const requestPurchaseRefund = async (purchaseId, reason) => {
  try {
    const response = await api.post(`/purchases/${purchaseId}/refund-request`, { reason });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
